import React from 'react';

import Testimonials from './components/Testimonials';
// import OurStory from './components/OurStory';
import WhyUs from './components/WhyUs';
import TakeControl from './components/TakeControl';

import ASSETS from '../../assets';
import Journey from './components/Journey';

const Home = () => {
  return (
    <>
      <div className='w-full min-h-[calc(100vh_-_24px)] rounded-[24px] bg-l-light-grey 2xl:px-[68px] lg:px-12 px-6 flex flex-col pt-[88px]'>
        <div className='flex-grow flex lg:flex-row flex-col items-center justify-between gap-9'>
          <div className=''>
            <p className='xl:text-[48px] xl:leading-[72px] md:text-[32px] md:leading-[48px]  text-3xl  text-l-primary font-bold leading-10'>
              Personalised Legal <br /> Advice, Just a Click Away
            </p>
            <p className='md:text-lg text-base max-w-[51ch] mt-6 text-l-primary'>
              Feeling swamped by a legal hurdle? You’re not alone. Legal issues
              can be complex and stressful, but they shouldn’t take you back.
              Legal Avenue allows you to access a roster of legal attorneys in a
              few simple steps. Whether you’re an individual, a family, or a
              company, our team of legal experts is here to guide you.
            </p>
            <p className='text-base text-l-grey-text lg:mt-[72px] mt-12'>
              Get The Mobile App
            </p>
            <div className='flex sm:flex-row flex-col sm:items-center gap-4 mt-4'>
              <a
                href='https://apps.apple.com/us/app/legal-avenue/id6474690584'
                target='_blank'
                rel='noreferrer'
              >
                <div className='w-[200px] bg-white rounded-md p-3 flex items-center gap-3'>
                  <img src={ASSETS.appStore} alt='' />
                  <div>
                    <p className='text-sm text-l-primary'>Download on the</p>
                    <p className='text-base font-semibold text-l-primary leading-5'>
                      App Store
                    </p>
                  </div>
                </div>
              </a>
              <a
                href='https://play.google.com/store/apps/details?id=com.techconsultivo.legalavenue'
                target='_blank'
                rel='noreferrer'
              >
                <div className='w-[200px] bg-white rounded-md p-3 flex items-center gap-3'>
                  <img src={ASSETS.playStore} alt='' />
                  <div>
                    <p className='text-sm text-l-primary'>Get in on</p>
                    <p className='text-base font-semibold text-l-primary leading-5'>
                      Play Store
                    </p>
                  </div>
                </div>
              </a>
            </div>
          </div>

          <div className='lg:pb-0 pb-4'>
            <img
              src={ASSETS.hero2x}
              className='2xl:max-w-[615px] lg:max-w-[500px]'
              alt=''
            />
          </div>
        </div>
      </div>
      <div className='lg:px-[68px] md:px-12 px-3 my-[120px]'>
        <Journey />
        <TakeControl />
        <WhyUs />
        <Testimonials />
        {/* <OurStory /> */}
      </div>
    </>
  );
};

export default Home;
